export default __webpack_public_path__ + "static/media/msg.62d3ca34.svg";